import { inject, injectionTarget } from '../../../loader/decorators/inject.js';
import { onModuleRegistration } from '../../../loader/decorators/on-module-registration.js';
import { StorageConsent, StorageHelper, StorageType } from '../storage/storage-helper.js';
import { IdStore } from './idstore.js';

declare const window: Window & yieldlove.Window;

const win = window;
win.pbjsYLHH = win.pbjsYLHH || {};
win.pbjsYLHH.que = win.pbjsYLHH.que || [];

interface RecoverId {
    name: string;
    key?: string;
    decode?: (raw: string) => string;
}

const identity = <T>(v: T) => v;

/**
 * Pull ids from localStorage that were set beforehand by Prebid.
 * Ids are created normally after the first auction from Prebid, which happens way after this script.
 * It's very likely that PreBid Ids will only be available on return visits of a user.
 */
@injectionTarget()
export class RecoverPrebidIds {

    @inject() #storageHelper!: StorageHelper;
    @inject() #idStore!: IdStore;

    constructor() {
        this.recoverPrebidIdsAfterRegistration();
    }

    /**
     * Gather ids, that can directly be read from localStorage.
     * as soon as local storage consent is available
     */
    @onModuleRegistration()
    public recoverPrebidIds(): void {
        const recoverIds: RecoverId[] = [
            { name: 'sharedid' },
            { name: 'criteo', key: 'cto_bidid' },
            { name: 'pubCommonId', key: '_pubcid' },
            { name: 'id5id', decode: raw => JSON.parse(decodeURIComponent(raw))['universal_uid'] || '' }
        ];

        for (const { name, key = name, decode = identity } of recoverIds) {
            this.#storageHelper.get(StorageType.LOCAL, StorageConsent.WAIT, key).then(value => {
                value && this.#idStore.setIdPromise(name, decode(value));
            });
        }
    }

    /**
     * waits for prebid to generate user Ids and
     * recovers the user Ids from localStorage
     */
    private recoverPrebidIdsAfterRegistration(): void {
        win.pbjsYLHH.que.push(() => {
            win.pbjsYLHH.getUserIdsAsync().then(() => {
                this.recoverPrebidIds();
            });
        });
    }
}
